import React, {useContext} from 'react'
import {Input, Form} from 'antd'
import {RecipeConText} from "../../../../../context/RecipeContext";

const RecipeName = () => {
    const {recipeAbstract} = useContext(RecipeConText)
    const [abstractState, setAbstractState] = recipeAbstract

    const handleInputChange = (event) => {
        let mockAbstract = Object.assign({}, abstractState)
        mockAbstract.name = event.target.value
        setAbstractState(mockAbstract)
    }

    return (
        <React.Fragment>
                <Form.Item
                    className={'font-bold'}
                    label={'Reçete Adı'}
                    name={'recipeName'}
                    onChange={handleInputChange}
                    labelAlign={'left'}
                >
                    <Input/>
                </Form.Item>
        </React.Fragment>
    )
}
export default RecipeName